import {
  APIComponentTypeAttributes,
  ApiComponentTypeOverviewRow,
} from '@ardoq/api-types';
import { fetchEntities, fetchJson, headers } from './api';
import { ApiResponse } from './types';

const fetchComponentTypeOverview = async (): ApiResponse<
  ApiComponentTypeOverviewRow[]
> => {
  const request = new Request(`/api/component-type/overview`, {
    headers,
  });
  return fetchJson<ApiComponentTypeOverviewRow[]>(request);
};

export const componentTypeApi = {
  fetchAll: fetchEntities<APIComponentTypeAttributes>('component-type'),
  fetchComponentTypeOverview,
};
